
import React, { useEffect, useState } from "react";
import { Pagination } from 'antd';
import { Wrapper, TableHeading, TableContent } from "./LeadListable.styled";
import { Table, Tag } from "components/common";
import { useHistory } from "react-router";
import { getUserPermissions } from "utils/text";
import { FaIdCard, FaCalendarCheck, FaHome } from "react-icons/fa";
import { HiStatusOnline } from "react-icons/hi";
import { IoIosCreate } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import { RiCalendar2Fill } from "react-icons/ri";
import moment from "moment";


const LeadListTable = ({ data, status, users, updatePagination, pagination, sortHandleChange }) => {
    const history = useHistory();

    const [offset, setOffset] = useState();
    const [limit, setLimit] = useState();

    function onShowSizeChange(current, pageSize) {
        updatePagination(current <= 0 ? 0 : current - 1, pageSize);
    }
    const handleChangePagination = (e) => {
        updatePagination(e <= 0 ? 0 : e - 1, undefined);
    }

    const handleOnChange = (pagiantion, filtering, sorter) => {
        if (sorter.column) {
            if (sorter.field === "firstName") {
                sortHandleChange('firstName')
            }
            else if (sorter.field === "lastname") {
                sortHandleChange('lastName')
            }
            else if (sorter.field === "status") {
                sortHandleChange('status')
            }
            else if (sorter.field === "appointmentTime") {
                sortHandleChange('appointmentTime')
            }
            else if (sorter.field === "dateCreated") {
                sortHandleChange('dateCreated')
            }
            else if (sorter.field === "setter") {
                sortHandleChange('setter')
            }
            else if (sorter.field === "address") {
                sortHandleChange('street')
            }
        }
    }

    const columns = [
        {
            title: (
                <TableHeading>
                    <FaIdCard />
                    <div className="title">First Name</div>
                </TableHeading>
            ),
            dataIndex: "firstName",
            render: (_, hits) => (
                <TableContent left={true}>
                    {hits?.firstName ? hits?.firstName : hits?.first_name ? hits?.first_name : hits?.customer_name?.split(" ")[0]}
                </TableContent>
            ),
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <FaIdCard />
                    <div className="title">Last Name</div>
                </TableHeading>
            ),
            dataIndex: "lastname",
            render: (_, hits) => (
                <TableContent left={true}>
                    {hits?.lastName ? hits?.lastName : hits?.last_name ? hits?.last_name : hits?.customer_name?.split(" ")[1]}
                </TableContent>
            ),
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <HiStatusOnline />
                    <div className="title">Status</div>
                </TableHeading>
            ),
            dataIndex: "status",
            key: "status",
            render: (value) => {
                let statusValue = status?.filter((el) => el?.id?.toString() == value);
                let color = "black"

                if (statusValue?.length) {
                    if (statusValue[0]?.name == "Sit") {
                        color = "grey"
                    }
                    else if (statusValue[0]?.name == "Sold") {
                        color = "#0096FF"
                    }
                }

                return (
                    <Tag color={"#131f28"} style={{ width: "100%", textAlign: "center", backgroundColor: color }}>
                        {statusValue?.length ? statusValue[0]?.name : "New"}
                    </Tag>
                );
            },
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <FaCalendarCheck />
                    <div className="title">Appointment</div>
                </TableHeading>
            ),
            dataIndex: "appointmentTime",
            key: "appointmentTime",

            render: (_, data) => (
                <TableContent>{moment(new Date(data?.appointmentTime)).format("DD/MM/YYYY hh:mm A")}</TableContent>
            ),
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <RiCalendar2Fill />
                    <div className="title">Date Created</div>
                </TableHeading>
            ),
            dataIndex: "dateCreated",
            key: "dateCreated",
            render: (_, data) => (
                <TableContent>{moment(new Date(data?.createdAt)).format("DD/MM/YYYY")}</TableContent>
            ),
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <IoIosCreate />
                    <div className="title">Created By</div>
                </TableHeading>
            ),
            dataIndex: "setter",
            key: "name",
            render: (_, data) => (
                <TableContent left={true}>
                    {data?.setter?.username ? data?.setter?.username : users?.find((e) => e.id === data?.setter)?.name}
                </TableContent>
            ),
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <FaHome />
                    <div className="title">Address</div>
                </TableHeading>
            ),
            dataIndex: "address",
            render: (_, hits) => (
                <TableContent left={true} lowercase={true} line={true} font={true} minWidth={true}> 
                    {hits.street} , {hits.city} , {hits.state}
                </TableContent>
            ),
            sorter: true,
        },
        {
            title: (
                <TableHeading>
                    <div className="title">Action</div>
                </TableHeading>
            ),
            render: (_, item) => (
                <a>
                    {getUserPermissions("edit-lead-action") && (
                        <MdEdit
                            size={20}
                            onClick={() => {
                                history.push(`lead/${item._id}`);
                            }}
                        />
                    )}
                </a>
            ),
        },
    ];

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const entries = Object.fromEntries(urlParams);
        setOffset(pagination?.offset || entries?.offset);
        setLimit(pagination?.limit || entries?.limit);
    }, [])

    return (
        <Wrapper>
            <Table
                pagination={false}
                rowKey={record => record._id}
                columns={columns}
                dataSource={data}
                onChange={handleOnChange}
            />
            {data && data?.length ? (
                <div className="pagination-table">
                    <Pagination showSizeChanger onShowSizeChange={onShowSizeChange} onChange={handleChangePagination} defaultCurrent={offset} defaultPageSize={limit} total={pagination.total} />
                </div>
            ) : null}
        </Wrapper>
    );
};

export default LeadListTable;
